export default __webpack_public_path__ + "static/media/img-05.5a0c87bd.png";